import SignUpForm from '../Setup/SignUpForm';

const SignUp = () => <SignUpForm />

export default SignUp;
